import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Stack, Group, TextInput } from "@mantine/core";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import { useCreateBadgeTemplate } from "../../api/badges";

const EMPTY_TEMPLATE_DATA = {
  size: { width: 4, height: 3, unit: "in" },
  hasBackground: false,
  backgroundTransform: { fit: "fit" },
  elements: [],
};

function CreateBadge({ opened, onClose, source }) {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);
  const eventId = currentWorkspace.eventId;

  const [name, setName] = useState(source ? `${source.name} copy` : "");

  const { mutate: createBadge, isPending } = useCreateBadgeTemplate();

  const handleClose = () => {
    setName("");
    onClose();
  };

  const handleCreate = () => {
    const payload = {
      eventId,
      name: name.trim(),
      templateData: source?.templateData ?? EMPTY_TEMPLATE_DATA,
    };

    // The backend copies the source's background into the new badge's own key
    // (see BadgesService.createBadgeTemplate); the list only holds a signed URL.
    if (source?.backgroundKey) {
      payload.sourceBadgeId = source.id;
    }

    createBadge(payload, {
      onSuccess: (data) => {
        handleClose();
        if (data?.id) navigate(`/app/badges/${data.id}`);
        else navigate("/app/badges");
      },
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={source ? "Create Copy Badge" : "Create Badge"}
      centered
    >
      <Stack>
        <TextInput
          label="Badge Name"
          placeholder="Attendee Badge"
          value={name}
          onChange={(e) => setName(e.currentTarget.value)}
          withAsterisk
          data-autofocus
        />

        <Group justify="flex-end" mt="sm">
          <Button variant="subtle" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            onClick={handleCreate}
            loading={isPending}
            disabled={!name.trim()}
          >
            Create &amp; Edit
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}

export default CreateBadge;
